/*=====================================
    折讓單列印

    Author: Gray
    CreateTime: 2018 / 08 / 10
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, {PureComponent} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import { formatDate } from 'react-day-picker/moment';
import styled from 'styled-components';

/*--------------------------
    Style
--------------------------*/
const ContentWidth = 760;
const Container = styled.div `
    width: 100%;
    height: 100%;
    padding: 30px;
    background-color: #fff;
    font-family: "sans-serif, Verdana, Arial, Helvetica, 細明體";
`;
const InvoiceContainer = styled.div`
    position: relative;
    width: ${ContentWidth}px; 
`;
const TopContent = styled.div`
    position: relative;
    margin-bottom: 30px;
    overflow: hidden;
`;
const TopLeftPannel = styled.div`
    width: 360px;
    float: left;
`;
const TopRightPannel = styled.div`
    width: calc(100% - 360px);
    padding: 20px 0 0 0;
    float: left;
`;
const TitleTable = styled.table`
    width: 100%;
    margin: 0;
    border: none;
    font-size: 12pt;

    td {
        border: none;
        padding: 2px 6px;
        margin: 0;        
    }
`;
const MiddleContent = styled.div`
    position: relative;
    margin-bottom: 30px;
`;
const BorderTable = styled.table`
    width: ${props => props.width ? props.width : 'auto'};
    margin: 0;
    font-size: 8pt;

    td {
        border: 1px solid #000;
        padding: 2px 6px;
        margin: 0;        
    }
`;
const AllCenterTbody = styled.tbody`
    td {
        text-align: center;
        vertical-align: middle;
    }
`;
const TransparentThead = styled.thead`
    th {
        border: none;
        background-color: #fff;
    }
`;
const BottomContent = styled.div`
    position: relative;
    overflow: hidden;
`;
const BottomLeftPannel = styled.div`
    width: 360px;
    float: left;
`;
const BottomRightPannel = styled.div`
    width: calc(100% - 360px);
    padding: 0 0 0 80px;
    float: left;
`;
const CenterAlignTD = styled.td`
    text-align: center;
`;
const CenterAlignTR = styled.tr`
    width: auto;
    text-align: center;

    td {
        text-align: center;
        vertical-align: middle;
        width: auto;
        padding: 3px 4px;
        margin: 0;
    }
`;
const LeftAlignTD = styled.td`
    text-align: left !important;
`;
const RightAlignTD = styled.td`
    text-align: right !important;
`;


/*--------------------------
    Main Component
--------------------------*/
class PrintAllowanceView extends PureComponent {

    constructor(props) {

        super(props);

        this.state = {
            isLoading: true,
            isError: false,
        }
    }

    componentDidMount() {

        const {
            match,
        } = this.props;

        const params = match.params || {};
        const allowancenumber = params.allowancenumber;

        if(allowancenumber) {
            this.props.allowanceActions.getAllowanceInfo({
                allowancenumber: allowancenumber,
            }).then(() => {
                this.setState({
                    isLoading: false,
                });
            }, () => {
                this.setState({
                    isError: true,
                });
            })
        }
    }

    render() {
        const {
            isLoading,
            isError,
        } = this.state;

        if(isLoading || isError){
            return (
                <Container />
            );
        }

        const {
            allowancenumber,
        } = this.props.match.params;

        const allowance = this.props.allowances[allowancenumber]; 
        const allowanceDayValue = formatDate(allowance.detail.allowancedate, 'YYYY-MM-DD');
        const invoiceYearValue = formatDate(allowance.detail.invoicedate, 'YYYY');
        // const invoiceYearValue = formatDate(allowance.detail.invoicedate, 'YYYY')-1911;
        const invoiceMonthValue = formatDate(allowance.detail.invoicedate, 'MM');
        const invoiceDayValue = formatDate(allowance.detail.invoicedate, 'DD');
        const istarttag = allowance.detail.invoicenumber.substring(0,2);
        const invoicenumber = allowance.detail.invoicenumber.substring(2);
        let _totaltax = 0;
        let totaluntaxed = 0;
        let pdtTaxMap = {};

        if(allowance.detail && Array.isArray(allowance.detail.pdtlist) && allowance.detail.pdtlist.length > 0) {
            allowance.detail.pdtlist.map((pdt, index)=>{
                const untaxed = Math.round(pdt.pdtprice * pdt.pdtcount);
                const taxed = Math.round(untaxed * 1.05);
                const tax = taxed - untaxed;

                _totaltax += tax;
                totaluntaxed += untaxed;
                pdtTaxMap[index] = tax;
            });
        }

        let total = Math.round(totaluntaxed * 1.05);
        const totaltax = total - totaluntaxed;
        const errorTax = _totaltax - totaltax;

        return (
            <Container>
                <InvoiceContainer>
                    <TopContent>
                        <TopLeftPannel>
                            <BorderTable>
                                <AllCenterTbody>
                                    <tr>
                                        <td rowSpan="3" colSpan="2" style={{width: '80px'}}>原開立銷貨發票單位</td>
                                        <td>名 稱</td>
                                        <td colSpan="8">沈氏藝術印刷股份有限公司</td>
                                    </tr>
                                    <tr>
                                        <td>營利事業<br/>統一編號</td>
                                        <td>1</td>
                                        <td>5</td>
                                        <td>8</td>
                                        <td>2</td>
                                        <td>0</td>
                                        <td>0</td>
                                        <td>9</td>
                                        <td>7</td>
                                    </tr>
                                    <tr>
                                        <td>營業所在<br/>地 址</td>
                                        <td colSpan="8">新北市土城區中央路一段365巷7號3樓</td>
                                    </tr>
                                </AllCenterTbody>
                            </BorderTable>
                        </TopLeftPannel>
                        <TopRightPannel>
                            <TitleTable>
                                <AllCenterTbody>
                                    <tr>
                                        <td><strong>電子發票銷貨退回、進貨退出或折讓證明聯</strong></td>
                                    </tr>
                                    <tr><td><br/></td></tr>
                                    <tr>
                                        <td>{allowanceDayValue}</td>
                                    </tr>
                                </AllCenterTbody>
                            </TitleTable>
                        </TopRightPannel>
                    </TopContent>
                    <MiddleContent>
                        <BorderTable width={ContentWidth + 'px'}>
                            <TransparentThead>
                                <tr>
                                    <th style={{width: '24px'}}></th>
                                    <th style={{width: '40px'}}></th>
                                    <th style={{width: '30px'}}></th>
                                    <th style={{width: '30px'}}></th>
                                    <th style={{width: '30px'}}></th>
                                    <th style={{width: '70px'}}></th>
                                    <th></th>
                                    <th style={{width: '50px'}}></th>
                                    <th style={{width: '50px'}}></th>
                                    <th style={{width: '70px'}}></th>
                                    <th style={{width: '50px'}}></th>
                                    <th style={{width: '24px'}}></th>
                                    <th style={{width: '24px'}}></th>
                                    <th style={{width: '24px'}}></th>
                                </tr>
                            </TransparentThead>
                            <tbody>
                                <CenterAlignTR >
                                    <td colSpan="6">開立發票</td>
                                    <td colSpan="5">退貨或折讓內容</td>
                                    <td colSpan="3">備註</td>
                                </CenterAlignTR>
                                <CenterAlignTR >
                                    <td>一<br/>般<br/>/<br/>特<br/>種</td>
                                    <td>年</td>
                                    <td>月</td>
                                    <td>日</td>
                                    <td>字<br/>軌</td>
                                    <td>號碼</td>
                                    <td>品名</td>
                                    <td>數量</td>
                                    <td>單價</td>
                                    <td>金額<br/>(不含稅之進貨額)</td>
                                    <td>營業<br/>稅額</td>
                                    <CenterAlignTD >應<br/>稅</CenterAlignTD>
                                    <CenterAlignTD >零<br/>稅<br/>率</CenterAlignTD>
                                    <CenterAlignTD >免<br/>稅</CenterAlignTD>
                                </CenterAlignTR>
                                {allowance.detail.pdtlist.map((pdt, index)=>{

                                    const untaxed = Math.round(pdt.pdtprice * pdt.pdtcount);
                                    const taxed = Math.round(untaxed * 1.05);
                                    let tax = pdtTaxMap[index];

                                    if(index === 0 && errorTax !== 0) {
                                        tax -= errorTax;
                                    }
                                    
                                    return (
                                        <CenterAlignTR key={index}>
                                            <td>一</td>
                                            <td>{invoiceYearValue}</td>
                                            <td>{invoiceMonthValue}</td>
                                            <td>{invoiceDayValue}</td>
                                            <td>{istarttag}</td>
                                            <td>{invoicenumber}</td>
                                            <LeftAlignTD>{pdt.pdtname}</LeftAlignTD>
                                            <RightAlignTD>{pdt.pdtcount}</RightAlignTD>
                                            <RightAlignTD>{pdt.pdtprice}</RightAlignTD>
                                            <RightAlignTD>{untaxed}</RightAlignTD>
                                            <RightAlignTD>{tax}</RightAlignTD>
                                            <td>Ｖ</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                        </CenterAlignTR>
                                    );
                                })}
                                <CenterAlignTR>
                                    <td colSpan="9">合 計</td>
                                    <RightAlignTD>{totaluntaxed}</RightAlignTD>
                                    <RightAlignTD>{totaltax}</RightAlignTD>
                                    <td colSpan="3">&nbsp;</td>
                                </CenterAlignTR>
                            </tbody>
                        </BorderTable>
                    </MiddleContent>
                    <BottomContent>
                        <BottomLeftPannel>
                            <p>本證明單所列進貨退出或折讓，確屬事實，特此證明。</p>
                            <p>簽收人：</p>
                        </BottomLeftPannel>
                        <BottomRightPannel>
                            <BorderTable width="100%">
                                <tr>
                                    <CenterAlignTD>進貨營業人(或原買受人)<br/>蓋統一發票專用章</CenterAlignTD>
                                </tr>
                                <tr>
                                    <td height="120"></td>
                                </tr>
                            </BorderTable>
                        </BottomRightPannel>
                    </BottomContent>
                </InvoiceContainer>
            </Container>
        );
    }
}

/*--------------------------
    Redux Props
--------------------------*/
const mapStateToProps = function(state) {

    return {
        allowances: state.allowance.allowances
    };
};

/*--------------------------
    Redux Action
--------------------------*/
const mapActionToProps = function(dispatch) {

    return {
        allowanceActions: bindActionCreators(actionCreators.allowanceActionCreators, dispatch),
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch)
    };
};

/*--------------------------
    Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    withRef: true
})(PrintAllowanceView);



// WEBPACK FOOTER //
// ./src/components/allowance/PrintAllowanceView.jsx